import UnitSelector from '../components/UnitSelector';
import UnitDataScopeNotice from '../components/UnitDataScopeNotice';
import UnitOperationGuard from '../components/UnitOperationGuard';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { Container } from 'react-bootstrap'; // Import Container
import Navbar from '../components/Navbar'; // Seu Navbar existente

// O MainLayout agora aceita props para repassá-las ao Navbar
const MainLayout = (props) => {
  // Você pode desestruturar as props específicas se preferir,
  // ou passar o objeto props inteiro para o Navbar.
  // Ex: const { userName, loginDateTime, entidadeNome, ...rest } = props;
  return (
    <div>
      {/* Repassa todas as props recebidas para o componente Navbar */}
      {/* Certifique-se de que seu componente Navbar espera e utiliza essas props,
          especialmente userName e loginDateTime. */}
      <Navbar {...props} />
      <UnitSelector />
      <UnitDataScopeNotice />
      <Container fluid className="xpto min-vh-100">
        <UnitOperationGuard><Outlet /></UnitOperationGuard>
      </Container>
    </div>
  );
};
export default MainLayout;
